import {
  toM,
  toTime
} from "../utils";
export default safe => {
  console.log(safe); //vue的this对象
  return {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: true,
    // searchMenuSpan: 6,
    tree: true,
    border: true,
    /** 表格索引 */
    index: false,
    /** 表格搜索显隐按钮 */
    searchShowBtn: true,
    /** 是否启用功能按钮 */
    searchIcon: true,
    searchIndex: 0,
    /** 表格查看按钮 */
    viewBtn: false,
    /** 表格新增按钮 */
    addBtn: false,
    /** 表格删除按钮 */
    delBtn: false,
    /** 表格修改按钮 */
    editBtn: false,
    /** 导出按钮 */
    excelBtn: true,
    /** 是否有选择框	 */
    selection: true,
    /** 表格高度 */
    height: 500,
    /** 表格搜索按钮 */
    // searchBtn: false,
    /** 表格清空按钮 */
    // emptyBtn: false,
    /** 开启拖拽功能 */
    // sortable: true,
    // dragHandler: true,
    // rowSort: true,
    // columnSort: true,
    menuWidth: 200,
    column: [{
        label: "文件名称",
        width: '250',
        prop: "name",
        slot: true,
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: false,
        // search: true,
        columnBtn: false
        /** 搜索项位置排序，序号越大越靠前 */
        // searchOrder: 1,
      },
      {
        label: "格式",
        prop: "fileFormat",
        /** 当内容过长被隐藏时显示 tooltip */
        overHidden: true,
      },
      {
        label: "大小",
        prop: "size",
        overHidden: true,
        formatter: (val) => {
          return toM(val.size) + 'M';
        }
      },
      {
        label: "时长",
        prop: "duration",
        overHidden: true,
        formatter: (val) => {
          return toTime(val.duration);
        }
      },
      {
        label: "码率",
        prop: "bitrate",
        formatter: (val) => {
          if (!val.bitrate) {
            return '-'
          }
          return (val.bitrate) + 'K';
        }
      },
      {
        label: "分辨率",
        prop: "width",
        formatter: (val) => {
          if (!val.width) {
            return '-'
          }
          return val.width + 'x' + val.height;
        }
      },
      {
        label: "状态",
        prop: "status",
        // 0待上传 1上传中 2上传完成 3上传失败 4转码中 5转码完成 6转码失败
        dicData: [{
            label: "待上传",
            value: 0
          },
          {
            label: "上传中",
            value: 1
          },
          {
            label: "上传完成",
            value: 2
          },
          {
            label: "上传失败",
            value: 3
          },
          {
            label: "转码中",
            value: 4
          },
          {
            label: "转码完成",
            value: 5
          },
          {
            label: "转码失败",
            value: 6
          }
        ]
      },
      {
        label: "上传时间",
        prop: "addTime",
      },
      {
        label: "",
        prop: "my",
        hide: true,
        showColumn: false,
        search: true,
        display: false,
        menuClassName: "myClass",
        searchslot: true
      }
    ]
  };
};
